export default {
    namespaced: true,

    state: {
        positions: [
            { id: 1, name: "Повар-сушист", color: "#97C1FF" },
            { id: 2, name: "Повар-пиццмейкер", color: "#97F2C7" },
            { id: 3, name: "Администратор филиала", color: "#E8EB8A" },
            { id: 4, name: "Водители", color: "#FFC0DE" },
            { id: 5, name: "Официант", color: "#D6D2FF" },
            { id: 6, name: "Остальные", color: "#DFE4EF" },
        ],

        branches: [
            { id: 1, name: "Филиал 1" },
            { id: 2, name: "Филиал 2" },
            { id: 3, name: "Филиал 3" },
            { id: 4, name: "Филиал 4" },
            { id: 5, name: "Филиал 5" },
            { id: 6, name: "Филиал 6" },
            { id: 7, name: "Филиал 7" },
            { id: 8, name: "Филиал 8" },
            { id: 9, name: "Филиал 9" },
            { id: 10, name: "Филиал 10" },
            { id: 11, name: "Филиал 11" },
            { id: 12, name: "Филиал 12" },
        ],

        fields: [
            {
                label: "Сотрудники",
                name: "employees",
                type: "list",
                value: { value: "all", label: "Все" },
                items: [
                    { value: "all", label: "Все" },
                    { value: "working", label: "Работающие" },
                    { value: "dismissed", label: "Уволенные" },
                ],
                cols: 2,
            },
            {
                label: "Статус",
                name: "status",
                type: "list",
                multiple: true,
                searchable: true,
                placeholder: "Все",
                reverse: true,
                value: null,
                reference: "employeesStatuses",
                cols: 4,
            },
            {
                label: "Характеристика",
                name: "characteristic",
                type: "list",
                multiple: true,
                searchable: true,
                placeholder: "Все",
                reverse: true,
                value: null,
                reference: "employeesCharacteristic",
                cols: 3,
            },
            {
                label: "Гражданство",
                name: "citizenship",
                type: "list",
                multiple: true,
                searchable: true,
                placeholder: "Все",
                reverse: true,
                value: null,
                reference: "employeesCitizenship",
                cols: 3,
            },
            {
                label: "Правовой статус",
                name: "legal-status",
                type: "list",
                multiple: true,
                searchable: true,
                placeholder: "Все",
                reverse: true,
                value: null,
                reference: "employeesLegalStatus",
                cols: 4,
            },
            {
                label: "Заполненность анкеты",
                name: "worksheet-completion",
                type: "list",
                placeholder: "Любая",
                clearable: true,
                value: null,
                reference: "employeesWorksheetCompletion",
                cols: 3,
            },
            {
                label: "Имя или телефон",
                name: "name-phone",
                type: "text",
                placeholder: "Любое",
                value: "",
                cols: 2,
            },
            {
                label: "Филиал",
                name: "branch",
                type: "list",
                searchable: true,
                placeholder: "Все",
                multiple: true,
                reverse: true,
                value: null,
                reference: "branches",
                cols: 3,
            },
            {
                label: "Должность",
                name: "position",
                type: "list",
                searchable: true,
                placeholder: "Все",
                multiple: true,
                reverse: true,
                value: null,
                reference: "positions",
                cols: 4,
            },
            {
                label: "Разряд",
                name: "rank",
                type: "list",
                searchable: true,
                placeholder: "Все",
                reverse: true,
                value: null,
                reference: "ranks",
                cols: 3,
                multiple: true,
            },
            {
                label: "Рабочий график",
                name: "working-schedule",
                type: "list",
                multiple: true,
                searchable: true,
                placeholder: "Все",
                reverse: true,
                value: null,
                reference: "workingSchedules",
                cols: 3,
            },
            {
                label: "Депозит",
                name: "deposit",
                type: "list",
                multiple: true,
                searchable: true,
                placeholder: "Все",
                reverse: true,
                value: null,
                reference: "deposits",
                cols: 3,
            },
            {
                label: "Может работать в нескольких филиалах",
                name: "can-work",
                type: "switcher",
                value: false,
                cols: 2,
            },
            {
                label: "Совмещает должности",
                name: "combines-positions",
                type: "switcher",
                value: false,
                cols: 2,
            },
            {
                label: "Проблемы с документами",
                name: "docs-troubles",
                type: "switcher",
                value: false,
                cols: 2,
            },
            {
                label: "Предыдущие места работы",
                name: "previous-jobs",
                type: "text",
                placeholder: "Любые",
                value: "",
                cols: 3,
            },
            {
                label: "Владение языками",
                name: "proficiency-language",
                type: "select",
                multiple: true,
                searchable: true,
                placeholder: "Любые",
                reverse: true,
                reference: "languages",
                cols: 4,
            },
            {
                label: "Владение программами",
                name: "proficiency-programs",
                type: "select",
                multiple: true,
                searchable: true,
                placeholder: "Любые",
                reverse: true,
                reference: "programs",
                cols: 4,
            },
            {
                label: "Должности на предыдущей работе",
                name: "previous-positions",
                type: "select",
                multiple: true,
                searchable: true,
                placeholder: "Любые",
                reverse: true,
                reference: "positions",
                cols: 4,
            },
            {
                label: "Должности за время работы компании",
                name: "positions-of-company",
                type: "select",
                multiple: true,
                searchable: true,
                placeholder: "Любые",
                reverse: true,
                reference: "positions",
                cols: 4,
            },
            {
                label: "Специальность",
                name: "specialty",
                type: "select",
                multiple: true,
                searchable: true,
                placeholder: "Любая",
                reverse: true,
                reference: "specialties",
                relatedReference: "positions",
                cols: 4,
            },
            {
                label: "Возраст",
                name: "age",
                type: "select",
                multiple: true,
                searchable: true,
                placeholder: "Любой",
                reverse: true,
                reference: "ages",
                cols: 4,
            },
            {
                label: "Продолжительность работы",
                name: "work-duration",
                type: "range",
                min: 0,
                max: 200,
                cols: 4,
                value: [0, 0],
            },
        ],

        filters: [],

        table: {
            type: "employees",
            actions: true,
            levels: 2,
            columns: [
                {
                    id: "worksheet",
                    label: "Анкетные данные",
                    fullName: "Анкетные данные",
                    isCategory: 1,
                    level: 0,
                    characteristic: "",
                },
                {
                    id: "filial",
                    label: "Филиал",
                    fullName: "Филиал",
                    type: "list",
                    parentColumnId: "worksheet",
                    reference: "filial",
                    level: 1,
                    characteristic: "",
                },
                {
                    id: "fullName",
                    label: "ФИО",
                    fullName: "ФИО",
                    type: "string",
                    parentColumnId: "worksheet",
                    level: 1,
                    characteristic: "",
                },
                {
                    id: "prs",
                    label: "Должность/Разряд/Специальность",
                    fullName: "Должность/Разряд/Специальность",
                    type: "string",
                    parentColumnId: "worksheet",
                    level: 1,
                    characteristic: "",
                },
                {
                    id: "workTime",
                    label: "Рабочий график",
                    fullName: "Рабочий график",
                    type: "string",
                    parentColumnId: "worksheet",
                    level: 1,
                    characteristic: "",
                },
                {
                    id: "employeeStatus",
                    label: "Статус сотрудника",
                    fullName: "Статус сотрудника",
                    type: "string",
                    parentColumnId: "worksheet",
                    level: 1,
                    characteristic: "",
                },
                {
                    id: "characteristic",
                    label: "Характеристика",
                    fullName: "Характеристика",
                    type: "string",
                    parentColumnId: "worksheet",
                    level: 1,
                    characteristic: "",
                },
                {
                    id: "citizenship",
                    label: "Гражданство",
                    fullName: "Гражданство",
                    type: "string",
                    parentColumnId: "worksheet",
                    level: 1,
                    characteristic: "",
                },
                {
                    id: "legalStatus",
                    label: "Правовой статус",
                    fullName: "Правовой статус",
                    type: "string",
                    parentColumnId: "worksheet",
                    level: 1,
                    characteristic: "",
                },
                {
                    id: "finance",
                    label: "Финансы",
                    fullName: "Финансы",
                    isCategory: 1,
                    level: 0,
                    characteristic: "",
                },
                {
                    id: "depositState",
                    label: "Состояние депозита",
                    fullName: "Состояние депозита",
                    type: "string",
                    parentColumnId: "finance",
                    level: 0,
                    characteristic: "",
                },
                {
                    id: "deposit",
                    label: "Депозит",
                    fullName: "Депозит",
                    type: "number",
                    parentColumnId: "finance",
                    level: 0,
                    characteristic: "",
                },
                {
                    id: "columnDate",
                    label: "Дата",
                    fullName: "Дата",
                    type: "date",
                    parentColumnId: "finance",
                    level: 0,
                    characteristic: "",
                },
            ],
            records: [
                {
                    id: 1,
                    filial: {
                        value: "Коммунарка",
                    },
                    fullName: {
                        value: "Сергеева Мария Владиславовна",
                        employee: {
                            rankStatus: "up",
                            docsTrouble: "Не заполнены обязательные докумены",
                            id: 1,
                            fullName: "Сергеева Мария Владиславовна",
                        },
                    },
                    prs: {
                        value: "Администратор филиала / 8 / основной повар",
                    },
                    workTime: {
                        value: "Только выходные",
                    },
                    employeeStatus: {
                        value: "Отстранен от работы",
                    },
                    characteristic: {
                        value: "Есть замечания",
                    },
                    legalStatus: {
                        value: "Временно пребывающий",
                    },
                    citizenship: {
                        value: "Туркменистан",
                    },
                    depositState: {
                        value: "Без депозита",
                        depositState: {
                            color: "none",
                            text: "Без депозита",
                        },
                    },
                    deposit: {
                        value: 30000,
                    },
                    columnDate: {
                        value: "10.10.2020",
                    },
                    _meta: {
                        worksheet: {
                            total: 22,
                            required: 5,
                            additional: 17,
                        },
                    },
                    isShowRow: true,
                },
                {
                    id: 2,
                    filial: {
                        value: "Коммунарка",
                    },
                    fullName: {
                        value: "Смирнова Ольга Ивановна",
                        employee: {
                            rankStatus: "down",
                            docsTrouble: "Просрочены документы: Документ1, Документ2...",
                            id: 1,
                            fullName: "Смирнова Ольга Ивановна",
                        },
                    },
                    prs: {
                        value: "Администратор филиала / 5 / основной",
                    },
                    workTime: {
                        value: "5/2",
                    },
                    employeeStatus: {
                        value: "Работает",
                    },
                    characteristic: {
                        value: "Хороший сотрудник",
                    },
                    legalStatus: {
                        value: "Резидент РФ",
                    },
                    citizenship: {
                        value: "Россия",
                    },
                    depositState: {
                        value: "Не внесен",
                        depositState: {
                            color: "error",
                            text: "Не внесен",
                        },
                    },
                    deposit: {
                        value: 30000,
                    },
                    columnDate: {
                        value: "10.10.2020",
                    },
                    _meta: {
                        worksheet: {
                            total: 22,
                            required: 0,
                            additional: 22,
                        },
                    },
                    isShowRow: true,
                },
                {
                    id: 3,
                    filial: {
                        value: "Коммунарка",
                    },
                    fullName: {
                        value: "Иванова Наталия Владимировна",
                        employee: {
                            rankStatus: "down",
                            id: 1,
                            fullName: "Иванова Наталия Владимировна",
                        },
                    },
                    prs: {
                        value: "Администратор филиала / 5 / основной",
                    },
                    workTime: {
                        value: "5/2",
                    },
                    employeeStatus: {
                        value: "Работает",
                    },
                    characteristic: {
                        value: "Хороший сотрудник",
                    },
                    legalStatus: {
                        value: "Резидент РФ",
                    },
                    citizenship: {
                        value: "Россия",
                    },
                    depositState: {
                        value: "Внесен",
                        depositState: {
                            color: "success",
                            text: "Внесен",
                        },
                    },
                    deposit: {
                        value: 30000,
                    },
                    columnDate: {
                        value: "10.10.2020",
                    },
                    _meta: {
                        worksheet: {
                            total: 22,
                            required: 0,
                            additional: 0,
                        },
                    },
                    isShowRow: true,
                },
                {
                    id: 4,
                    filial: {
                        value: "Коммунарка",
                    },
                    fullName: {
                        value: "Иванова Наталия Владимировна",
                        employee: {
                            rankStatus: "up",
                            id: 1,
                            fullName: "Иванова Наталия Владимировна",
                        },
                    },
                    prs: {
                        value: "Администратор филиала / 5 / основной",
                    },
                    workTime: {
                        value: "5/2",
                    },
                    employeeStatus: {
                        value: "Работает",
                    },
                    characteristic: {
                        value: "Хороший сотрудник",
                    },
                    legalStatus: {
                        value: "Резидент РФ",
                    },
                    citizenship: {
                        value: "Россия",
                    },
                    depositState: {
                        value: "Внесен частично",
                        depositState: {
                            color: "warning",
                            text: "Внесен излишне",
                        },
                    },
                    deposit: {
                        value: 30000,
                    },
                    columnDate: {
                        value: "10.10.2020",
                    },
                    _meta: {
                        worksheet: {
                            total: 22,
                            required: 6,
                            additional: 2,
                        },
                    },
                    isShowRow: true,
                },
            ],
        },

        tablePersonalEmployeeMoveInCompany: {
            actions: false,
            levels: 1,
            columns: [
                {
                    id: "change",
                    label: "Изменение",
                    fullName: "Изменение",
                    type: "string",
                    level: 0,
                    width: "52%",
                    colspan: 1,
                    characteristic: "",
                },
                {
                    id: "columnDate",
                    label: "Дата изменения",
                    fullName: "Дата изменения",
                    type: "date",
                    width: "16%",
                    level: 0,
                    colspan: 1,
                    characteristic: "",
                },
                {
                    id: "changeAuthor",
                    label: "Автор изменения",
                    fullName: "Автор изменения",
                    type: "string",
                    width: "32%",
                    level: 0,
                    colspan: 1,
                    characteristic: "",
                },
            ],
            records: [
                {
                    change: {
                        value: "Присвоен <b>2 разряд</b>",
                    },
                    columnDate: {
                        value: "16.09.2020",
                    },
                    changeAuthor: {
                        value: "Константинопольский Александр",
                    },
                    isShowRow: true,
                },
                {
                    change: {
                        value: "Перезакреплен за филиалом <b>Щербинка</b>",
                    },
                    columnDate: {
                        value: "02.09.2020",
                    },
                    changeAuthor: {
                        value: "admin_scherbinka",
                    },
                    isShowRow: true,
                },
                {
                    change: {
                        value: "Присвоен <b>1 разряд</b>",
                    },
                    columnDate: {
                        value: "29.07.2020",
                    },
                    changeAuthor: {
                        value: "admin_scherbinka",
                    },
                    isShowRow: true,
                },
                {
                    change: {
                        value: "Закреплен за филиалом <b>Подольск</b>",
                    },
                    columnDate: {
                        value: "09.05.2020",
                    },
                    changeAuthor: {
                        value: "admin_podolsk",
                    },
                    isShowRow: true,
                },
                {
                    change: {
                        value: "Принят на должность <b>Повар-сушист</b>",
                    },
                    columnDate: {
                        value: "09.05.2020",
                    },
                    changeAuthor: {
                        value: "admin_podolsk",
                    },
                    isShowRow: true,
                },
                {
                    change: {
                        value: "Присвоен 1 разряд",
                    },
                    columnDate: {
                        value: "16.09.2020",
                    },
                    changeAuthor: {
                        value: "Константинопольский Александр ",
                    },
                    isShowRow: true,
                },
                {
                    change: {
                        value: "Закреплен за филиалом <b>Щербинка</b>",
                    },
                    columnDate: {
                        value: "02.09.2020",
                    },
                    changeAuthor: {
                        value: "admin_scherbinka",
                    },
                    isShowRow: true,
                },
                {
                    change: {
                        value: "Принят на должность <b>Повар-универсал</b>",
                    },
                    columnDate: {
                        value: "29.07.2020",
                    },
                    changeAuthor: {
                        value: "admin_scherbinka",
                    },
                    isShowRow: true,
                },
            ],

            recordsWithGroups: [
                {
                    categoryName: "Повар-сушист",
                    records: [
                        {
                            change: {
                                value: "Присвоен <b>2 разряд</b>",
                            },
                            columnDate: {
                                value: "16.09.2020",
                            },
                            changeAuthor: {
                                value: "Константинопольский Александр",
                            },
                            isShowRow: true,
                        },
                        {
                            change: {
                                value: "Перезакреплен за филиалом <b>Щербинка</b>",
                            },
                            columnDate: {
                                value: "02.09.2020",
                            },
                            changeAuthor: {
                                value: "admin_scherbinka",
                            },
                            isShowRow: true,
                        },
                        {
                            change: {
                                value: "Присвоен 1 разряд",
                            },
                            columnDate: {
                                value: "29.07.2020",
                            },
                            changeAuthor: {
                                value: "admin_scherbinka",
                            },
                            isShowRow: true,
                        },
                        {
                            change: {
                                value: "Закреплен за филиалом <b>Подольск</b>",
                            },
                            columnDate: {
                                value: "09.05.2020",
                            },
                            changeAuthor: {
                                value: "admin_podolsk",
                            },
                            isShowRow: true,
                        },
                        {
                            change: {
                                value: "Принят на должность <b>Повар-сушист</b>",
                            },
                            columnDate: {
                                value: "09.05.2020",
                            },
                            changeAuthor: {
                                value: "admin_podolsk",
                            },
                            isShowRow: true,
                        },
                    ],
                },
                {
                    categoryName: "Повар-универсал",
                    records: [
                        {
                            change: {
                                value: "Присвоен <b>1 разряд</b>",
                            },
                            columnDate: {
                                value: "16.09.2020",
                            },
                            changeAuthor: {
                                value: "Константинопольский Александр ",
                            },
                            isShowRow: true,
                        },
                        {
                            change: {
                                value: "Закреплен за филиалом <b>Щербинка</b>",
                            },
                            columnDate: {
                                value: "02.09.2020",
                            },
                            changeAuthor: {
                                value: "admin_scherbinka",
                            },
                            isShowRow: true,
                        },
                        {
                            change: {
                                value: "Принят на должность <b>Повар-универсал</b>",
                            },
                            columnDate: {
                                value: "29.07.2020",
                            },
                            changeAuthor: {
                                value: "admin_scherbinka",
                            },
                            isShowRow: true,
                        },
                    ],
                },
            ],
        },

        tablePersonalEmployeeMainFactors: {
            actions: true,
            levels: 1,
            columns: [
                {
                    id: "change",
                    label: "Смена",
                    fullName: "Смена",
                    type: "string",
                    level: 0,
                    colspan: 2,
                    characteristic: "",
                },
                {
                    id: "placeOfWork",
                    label: "Место работы",
                    fullName: "Место работы",
                    type: "string",
                    level: 0,
                    colspan: 1,
                    characteristic: "",
                },
                {
                    id: "total",
                    label: "Всего, ฿",
                    fullName: "Всего, ฿",
                    type: "number",
                    colspan: 1,
                    level: 0,
                    characteristic: "",
                },
                {
                    id: "mainPartSalary",
                    label: "Основная часть ЗП, ฿",
                    fullName: "Основная часть ЗП, ฿",
                    type: "number",
                    level: 0,
                    colspan: 1,
                    characteristic: "",
                },
                {
                    id: "variablePartSalary",
                    label: "Перемен. часть ЗП, ฿",
                    fullName: "Переменная часть ЗП, ฿",
                    type: "number",
                    level: 0,
                    colspan: 1,
                    characteristic: "",
                },
                {
                    id: "depreciation",
                    label: "Депрем., ฿",
                    fullName: "Депремирование, ฿",
                    type: "number",
                    level: 0,
                    colspan: 1,
                    characteristic: "",
                },
                {
                    id: "rewardsShift",
                    label: "Поощр-й за смену, ฿",
                    fullName: "Поощрений за смену, ฿",
                    type: "string",
                    level: 0,
                    colspan: 1,
                    characteristic: "",
                },
                {
                    id: "finesPerShift",
                    label: "Штрафов за смену, ฿",
                    fullName: "Штрафов за смену, ฿",
                    type: "string",
                    level: 0,
                    colspan: 1,
                    characteristic: "",
                },
            ],
            records: [
                {
                    change: {
                        values: [
                            { value: "16.09.2020", rowspan: 1, colId: 1 },
                            { value: "11:00-21:00", rowspan: 1, colId: 2 },
                        ],
                    },
                    placeOfWork: {
                        value: "Щербинка",
                    },
                    total: {
                        value: "4 400",
                    },
                    mainPartSalary: {
                        value: "3 800",
                    },
                    variablePartSalary: {
                        value: "800",
                    },
                    depreciation: {
                        value: "0",
                    },
                    rewardsShift: {
                        value: "1 / 100",
                    },
                    finesPerShift: {
                        value: "1 / 300",
                    },
                    isShowRow: true,
                },
                {
                    change: {
                        values: [
                            { value: "14.09.2020", rowspan: 1, colId: 1 },
                            { value: "11:00-21:00", rowspan: 1, colId: 2 },
                        ],
                    },
                    placeOfWork: {
                        value: "Щербинка",
                    },
                    total: {
                        value: "3 650",
                    },
                    mainPartSalary: {
                        value: "3 600",
                    },
                    variablePartSalary: {
                        value: "150",
                    },
                    depreciation: {
                        value: "100",
                    },
                    rewardsShift: {
                        value: "0 / 0",
                    },
                    finesPerShift: {
                        value: "0 / 0",
                    },
                    isShowRow: true,
                },
                {
                    change: {
                        values: [
                            { value: "12.09.2020", rowspan: 1, colId: 1 },
                            { value: "11:00-21:00", rowspan: 1, colId: 2 },
                        ],
                    },
                    placeOfWork: {
                        value: "Щербинка",
                    },
                    total: {
                        value: "3 900",
                    },
                    mainPartSalary: {
                        value: "3 900",
                    },
                    variablePartSalary: {
                        value: "300",
                    },
                    depreciation: {
                        value: "0",
                    },
                    rewardsShift: {
                        value: "0 / 0",
                    },
                    finesPerShift: {
                        value: "1 / 300",
                    },
                    isShowRow: true,
                },
                {
                    change: {
                        values: [
                            { value: "10.09.2020", rowspan: 2, colId: 1 },
                            { value: "11:00-15:00", rowspan: 1, colId: 2 },
                        ],
                    },
                    placeOfWork: {
                        value: "Щербинка",
                    },
                    total: {
                        value: "1 800",
                    },
                    mainPartSalary: {
                        value: "1 800",
                    },
                    variablePartSalary: {
                        value: "0",
                    },
                    depreciation: {
                        value: "0",
                    },
                    rewardsShift: {
                        value: "0 / 0",
                    },
                    finesPerShift: {
                        value: "0 / 0",
                    },
                    isShowRow: true,
                },
                {
                    change: {
                        values: [{ hiddenValue: "10.09.2020" }, { value: "16:00-23:00", rowspan: 1, colId: 2 }],
                    },
                    placeOfWork: {
                        value: "Удалённо",
                    },
                    total: {
                        value: "1 800",
                    },
                    mainPartSalary: {
                        value: "1 800",
                    },
                    variablePartSalary: {
                        value: "0",
                    },
                    depreciation: {
                        value: "0",
                    },
                    rewardsShift: {
                        value: "0 / 0",
                    },
                    finesPerShift: {
                        value: "0 / 0",
                    },
                    isShowRow: true,
                },
            ],
        },

        tablePersonalFinancePersonalAccount: {
            type: "finance",
            actions: true,
            levels: 1,
            columns: [
                {
                    id: "event",
                    label: "Событие, ฿",
                    fullName: "Изменение",
                    type: "string",
                    level: 0,
                    width: "11%",
                    colspan: 1,
                    characteristic: "",
                },
                {
                    id: "date",
                    label: "Дата",
                    fullName: "Дата",
                    type: "date",
                    width: "10%",
                    level: 0,
                    colspan: 1,
                    characteristic: "",
                },
                {
                    id: "whoCommitted",
                    label: "Кто внес/снял",
                    fullName: "Кто внес/снял",
                    type: "string",
                    width: "30%",
                    level: 0,
                    colspan: 1,
                    characteristic: "",
                },
                {
                    id: "reason",
                    label: "Причина",
                    fullName: "Причина",
                    type: "string",
                    width: "50%",
                    level: 0,
                    colspan: 1,
                    characteristic: "",
                },
            ],
            records: [
                {
                    event: {
                        value: -1200,
                    },
                    date: {
                        value: "10.02.2021",
                    },
                    whoCommitted: {
                        value: "Константинопольский Александр",
                    },
                    reason: {
                        value: "Халатное отношение к работе",
                    },
                    comment: {
                        value: null,
                    },
                    isShowRow: true,
                },
                {
                    event: {
                        value: 150,
                    },
                    date: {
                        value: "29.01.2021",
                    },
                    whoCommitted: {
                        value: "Смирнова Анастасия",
                    },
                    reason: {
                        value: "Премия",
                    },
                    comment: {
                        value: "Комментарий-1",
                    },
                    isShowRow: true,
                },
                {
                    event: {
                        value: -300,
                    },
                    date: {
                        value: "29.01.2021",
                    },
                    whoCommitted: {
                        value: "admin",
                    },
                    reason: {
                        value: "Отсутствие сотрудника на рабочем месте от 20 до 30 минут",
                    },
                    comment: {
                        value: "Комментарий-2",
                    },
                    isShowRow: true,
                },
                {
                    event: {
                        value: 150,
                    },
                    date: {
                        value: "28.11.2020",
                    },
                    whoCommitted: {
                        value: "Смирнова Анастасия",
                    },
                    reason: {
                        value: "Премия",
                    },
                    comment: {
                        value: null,
                    },
                    isShowRow: true,
                },
            ],
        },

        tablePersonalFinanceDeposit: {
            type: "finance",
            actions: true,
            levels: 1,
            columns: [
                {
                    id: "event",
                    label: "Событие, ฿",
                    fullName: "Изменение",
                    type: "string",
                    level: 0,
                    width: "17%",
                    colspan: 1,
                    characteristic: "",
                },
                {
                    id: "date",
                    label: "Дата",
                    fullName: "Дата",
                    type: "date",
                    width: "16%",
                    level: 0,
                    colspan: 1,
                    characteristic: "",
                },
                {
                    id: "whoCommitted",
                    label: "Кто внес/снял",
                    fullName: "Кто внес/снял",
                    type: "string",
                    width: "46%",
                    level: 0,
                    colspan: 1,
                    characteristic: "",
                },
                {
                    id: "balance",
                    label: "Баланс, ฿",
                    fullName: "Баланс, ฿",
                    type: "string",
                    width: "17%",
                    level: 0,
                    colspan: 1,
                    characteristic: "",
                },
            ],
            records: [
                {
                    event: {
                        value: -2600,
                    },
                    date: {
                        value: "10.02.2021",
                    },
                    whoCommitted: {
                        value: "Константинопольский Александр",
                    },
                    balance: {
                        value: 1000,
                    },
                    comment: {
                        value: null,
                    },
                    isShowRow: true,
                },
                {
                    event: {
                        value: 2600,
                    },
                    date: {
                        value: "29.01.2021",
                    },
                    whoCommitted: {
                        value: "Смирнова Анастасия",
                    },
                    balance: {
                        value: 3000,
                    },
                    comment: {
                        value: "Комментарий-1",
                    },
                    isShowRow: true,
                },
                {
                    event: {
                        value: -100,
                    },
                    date: {
                        value: "19.12.2020",
                    },
                    whoCommitted: {
                        value: "admin",
                    },
                    balance: {
                        value: 400,
                    },
                    comment: {
                        value: "Комментарий-2",
                    },
                    isShowRow: true,
                },
                {
                    event: {
                        value: 500,
                    },
                    date: {
                        value: "28.11.2020",
                    },
                    whoCommitted: {
                        value: "Смирнова Анастасия",
                    },
                    balance: {
                        value: 500,
                    },
                    comment: {
                        value: null,
                    },
                    isShowRow: true,
                },
            ],
        },
        tableInventoryItemsByPositions: {
            type: "finance",
            actions: true,
            levels: 1,
            columns: [
                {
                    id: "position",
                    label: "Позиция",
                    fullName: "Позиция",
                    type: "string",
                    level: 0,
                    width: "31%",
                    colspan: 1,
                    characteristic: "",
                },
                {
                    id: "status",
                    label: "Статус",
                    fullName: "Статус",
                    type: "date",
                    width: "13%",
                    level: 0,
                    colspan: 1,
                    characteristic: "",
                },
                {
                    id: "shelfLife",
                    label: "Срок годности",
                    fullName: "Срок годности",
                    type: "string",
                    width: "10%",
                    level: 0,
                    colspan: 1,
                    characteristic: "",
                },
                {
                    id: "dateIssue",
                    label: "Дата выдачи",
                    fullName: "Дата выдачи",
                    type: "string",
                    width: "9%",
                    level: 0,
                    colspan: 1,
                    characteristic: "",
                },
                {
                    id: "whoIssued",
                    label: "Кто выдал",
                    fullName: "Кто выдал",
                    type: "string",
                    width: "23%",
                    level: 0,
                    colspan: 1,
                    characteristic: "",
                },
            ],
            records: [
                {
                    categoryName: "Повар-сушист",
                    records: [
                        {
                            id: 1,
                            position: {
                                value: "Китель поварской",
                            },
                            status: {
                                value: "Выдан",
                                desc: "issued",
                            },
                            shelfLife: {
                                value: "10.04.2021",
                            },
                            dateIssue: {
                                value: "10.10.2020",
                            },
                            whoIssued: {
                                value: "Константинопольский Александр",
                            },
                            isShowRow: true,
                        },
                        {
                            id: 2,
                            position: {
                                value: "Китель поварской",
                            },
                            status: {
                                value: "Выдан, просрочен",
                                desc: "issuedoverdue",
                            },
                            shelfLife: {
                                value: "10.02.2021",
                            },
                            dateIssue: {
                                value: "10.06.2020",
                            },
                            whoIssued: {
                                value: "Константинопольский Александр",
                            },
                            isShowRow: true,
                        },
                        {
                            id: 3,
                            position: {
                                value: "Футболка поварская",
                            },
                            status: {
                                value: "Не выдан",
                                desc: "notissued",
                            },
                            shelfLife: {
                                value: "",
                            },
                            dateIssue: {
                                value: "",
                            },
                            whoIssued: {
                                value: "",
                            },
                            isShowRow: true,
                        },
                        {
                            id: 4,
                            position: {
                                value: "Брюки поварские",
                            },
                            status: {
                                value: "Не выдан",
                                desc: "notissued",
                            },
                            shelfLife: {
                                value: "",
                            },
                            dateIssue: {
                                value: "",
                            },
                            whoIssued: {
                                value: "",
                            },
                            isShowRow: true,
                        },
                        {
                            id: 5,
                            position: {
                                value: "Фартук поварской",
                            },
                            status: {
                                value: "Выдан",
                                desc: "issued",
                            },
                            shelfLife: {
                                value: "10.04.2021",
                            },
                            dateIssue: {
                                value: "10.01.2021",
                            },
                            whoIssued: {
                                value: "Константинопольский Александр",
                            },
                            isShowRow: true,
                        },
                        {
                            id: 6,
                            position: {
                                value: "Бандана поварская",
                            },
                            status: {
                                value: "Выдан",
                                desc: "issued",
                            },
                            shelfLife: {
                                value: "10.04.2021",
                            },
                            dateIssue: {
                                value: "10.01.2021",
                            },
                            whoIssued: {
                                value: "admin_scherbinka",
                            },
                            isShowRow: true,
                        },
                    ],
                },
                {
                    categoryName: "Повар-универсал",
                    records: [
                        {
                            id: 7,
                            position: {
                                value: "Китель поварской",
                            },
                            status: {
                                value: "Выдан",
                                desc: "issued",
                            },
                            shelfLife: {
                                value: "10.04.2021",
                            },
                            dateIssue: {
                                value: "10.10.2020",
                            },
                            whoIssued: {
                                value: "Константинопольский Александр",
                            },
                            isShowRow: true,
                        },
                        {
                            id: 8,
                            position: {
                                value: "Футболка поварская",
                            },
                            status: {
                                value: "Не выдан",
                                desc: "notissued",
                            },
                            shelfLife: {
                                value: "",
                            },
                            dateIssue: {
                                value: "",
                            },
                            whoIssued: {
                                value: "",
                            },
                            isShowRow: true,
                        },
                        {
                            id: 9,
                            position: {
                                value: "Брюки поварские",
                            },
                            status: {
                                value: "Не выдан",
                                desc: "notissued",
                            },
                            shelfLife: {
                                value: "",
                            },
                            dateIssue: {
                                value: "",
                            },
                            whoIssued: {
                                value: "",
                            },
                            isShowRow: true,
                        },
                        {
                            id: 10,
                            position: {
                                value: "Фартук поварской",
                            },
                            status: {
                                value: "Выдан",
                                desc: "issued",
                            },
                            shelfLife: {
                                value: "10.04.2021",
                            },
                            dateIssue: {
                                value: "10.01.2021",
                            },
                            whoIssued: {
                                value: "Константинопольский Александр",
                            },
                            isShowRow: true,
                        },
                        {
                            id: 11,
                            position: {
                                value: "Бандана поварская",
                            },
                            status: {
                                value: "Выдан",
                                desc: "issued",
                            },
                            shelfLife: {
                                value: "10.04.2021",
                            },
                            dateIssue: {
                                value: "10.01.2021",
                            },
                            whoIssued: {
                                value: "admin_scherbinka",
                            },
                            isShowRow: true,
                        },
                    ],
                },
            ],
        },

        tableInventoryItemsChanges: {
            type: "inventory-items",
            actions: false,
            levels: 1,
            columns: [
                {
                    id: "position",
                    label: "Позиция",
                    fullName: "Позиция",
                    type: "string",
                    level: 0,
                    // width: '10%',
                    colspan: 1,
                    characteristic: "",
                },
                {
                    id: "post",
                    label: "Должность",
                    fullName: "Должность",
                    type: "string",
                    // width: '9.5%',
                    level: 0,
                    colspan: 1,
                    characteristic: "",
                },
                {
                    id: "status",
                    label: "Статус",
                    fullName: "Статус",
                    type: "string",
                    // width: '26%',
                    level: 0,
                    colspan: 1,
                    characteristic: "",
                },
                {
                    id: "dateIssue",
                    label: "Дата выдачи",
                    fullName: "Дата выдачи",
                    type: "date",
                    // width: '50%',
                    level: 0,
                    colspan: 1,
                    characteristic: "",
                },
                {
                    id: "whoIssued",
                    label: "Автор изменения",
                    fullName: "Автор изменения",
                    type: "string",
                    // width: '50%',
                    level: 0,
                    colspan: 1,
                    characteristic: "",
                },
            ],
            columnsWithGroups: [
                {
                    id: "position",
                    label: "Позиция",
                    fullName: "Позиция",
                    type: "string",
                    level: 0,
                    // width: '10%',
                    colspan: 1,
                    characteristic: "",
                },
                {
                    id: "status",
                    label: "Статус",
                    fullName: "Статус",
                    type: "string",
                    // width: '26%',
                    level: 0,
                    colspan: 1,
                    characteristic: "",
                },
                {
                    id: "dateIssue",
                    label: "Дата выдачи",
                    fullName: "Дата выдачи",
                    type: "date",
                    // width: '50%',
                    level: 0,
                    colspan: 1,
                    characteristic: "",
                },
                {
                    id: "whoIssued",
                    label: "Автор изменения",
                    fullName: "Автор изменения",
                    type: "string",
                    // width: '50%',
                    level: 0,
                    colspan: 1,
                    characteristic: "",
                },
            ],
            records: [
                {
                    position: {
                        value: "Фартук поварской",
                    },
                    post: {
                        value: "Повар-сушист",
                    },
                    status: {
                        value: "Отменен",
                    },
                    dateIssue: {
                        value: "10.12.2020",
                    },
                    whoIssued: {
                        value: "Константинопольский Александр",
                    },
                    isShowRow: true,
                },
                {
                    position: {
                        value: "Китель поварской",
                    },
                    post: {
                        value: "Повар-сушист",
                    },
                    status: {
                        value: "Выдан",
                    },
                    dateIssue: {
                        value: "10.12.2020",
                    },
                    whoIssued: {
                        value: "Константинопольский Александр",
                    },
                    isShowRow: true,
                },
                {
                    position: {
                        value: "Бандана поварская",
                    },
                    post: {
                        value: "Повар-сушист",
                    },
                    status: {
                        value: "Отменен",
                    },
                    dateIssue: {
                        value: "10.12.2020",
                    },
                    whoIssued: {
                        value: "admin_scherbinka",
                    },
                    isShowRow: true,
                },
                {
                    position: {
                        value: "Фартук поварской",
                    },
                    post: {
                        value: "Администратор филиала",
                    },
                    status: {
                        value: "Выдан",
                    },
                    dateIssue: {
                        value: "10.12.2020",
                    },
                    whoIssued: {
                        value: "admin_scherbinka",
                    },
                    isShowRow: true,
                },
            ],
            recordsWithGroups: [
                {
                    categoryName: "Повар-сушист",
                    records: [
                        {
                            position: {
                                value: "Фартук поварской",
                            },
                            status: {
                                value: "Отменен",
                            },
                            dateIssue: {
                                value: "10.12.2020",
                            },
                            whoIssued: {
                                value: "Константинопольский Александр",
                            },
                            isShowRow: true,
                        },
                        {
                            position: {
                                value: "Китель поварской",
                            },
                            status: {
                                value: "Выдан",
                            },
                            dateIssue: {
                                value: "10.12.2020",
                            },
                            whoIssued: {
                                value: "Константинопольский Александр",
                            },
                            isShowRow: true,
                        },
                        {
                            position: {
                                value: "Бандана поварская",
                            },
                            status: {
                                value: "Отменен",
                            },
                            dateIssue: {
                                value: "10.12.2020",
                            },
                            whoIssued: {
                                value: "admin_scherbinka",
                            },
                            isShowRow: true,
                        },
                    ],
                },
                {
                    categoryName: "Администратор филиала",
                    records: [
                        {
                            position: {
                                value: "Фартук поварской",
                            },
                            status: {
                                value: "Выдан",
                            },
                            dateIssue: {
                                value: "10.12.2020",
                            },
                            whoIssued: {
                                value: "admin_scherbinka",
                            },
                            isShowRow: true,
                        },
                    ],
                },
            ],
        },

        tablePersonalEmployeeDiscipline: {
            type: "discipline",
            actions: false,
            levels: 1,
            columns: [
                {
                    id: "filial",
                    label: "Филиал",
                    fullName: "Изменение",
                    type: "string",
                    level: 0,
                    width: "8.5%",
                    colspan: 1,
                    characteristic: "",
                },
                {
                    id: "date",
                    label: "Дата",
                    fullName: "Дата",
                    type: "date",
                    width: "7%",
                    level: 0,
                    colspan: 1,
                    characteristic: "",
                },
                {
                    id: "measure",
                    label: "Мера",
                    fullName: "Мера",
                    type: "string",
                    width: "8%",
                    level: 0,
                    colspan: 1,
                    characteristic: "",
                },
                {
                    id: "reason",
                    label: "Причина",
                    fullName: "Причина",
                    type: "string",
                    width: "32%",
                    level: 0,
                    colspan: 1,
                    characteristic: "",
                },
                {
                    id: "amount",
                    label: "Сумма",
                    fullName: "Сумма",
                    type: "string",
                    width: "6.5%",
                    level: 0,
                    colspan: 1,
                    characteristic: "",
                },
                {
                    id: "whoIssued",
                    label: "Выписал",
                    fullName: "Выписал",
                    type: "string",
                    width: "19%",
                    level: 0,
                    colspan: 1,
                    characteristic: "",
                },
                {
                    id: "replyByDate",
                    label: "Ответ к дате",
                    fullName: "Ответ к дате",
                    type: "date",
                    width: "9%",
                    level: 0,
                    colspan: 1,
                    characteristic: "",
                },
                {
                    id: "explanatory",
                    label: "Объясн-я",
                    fullName: "Объяснительная",
                    type: "string",
                    width: "10%",
                    level: 0,
                    colspan: 1,
                    characteristic: "",
                },
            ],
            records: [
                {
                    filial: {
                        value: "Щербинка",
                    },
                    date: {
                        value: "26.02.2021",
                    },
                    measure: {
                        value: "Нарушение",
                    },
                    reason: {
                        value: "Расхождение в списании айко/бланк списания",
                    },
                    amount: {
                        value: null,
                    },
                    whoIssued: {
                        value: "admin scherbinka",
                    },
                    replyByDate: {
                        value: "28.02.2021",
                    },
                    explanatory: {
                        value: "need_write",
                    },
                    isShowRow: true,
                },
                {
                    filial: {
                        value: "Коммунарка",
                    },
                    date: {
                        value: "08.02.2021",
                    },
                    measure: {
                        value: "Нарушение",
                    },
                    reason: {
                        value: "Не внесен магазинный чек в iiko",
                    },
                    amount: {
                        value: null,
                    },
                    whoIssued: {
                        value: "Константинопольский Александр",
                    },
                    replyByDate: {
                        value: "",
                    },
                    explanatory: {
                        value: "",
                    },
                    isShowRow: true,
                },
                {
                    filial: {
                        value: "Коммунарка",
                    },
                    date: {
                        value: "11.01.2021",
                    },
                    measure: {
                        value: "Штраф",
                    },
                    reason: {
                        value: "Оплата десерта со скидкой 50%",
                    },
                    amount: {
                        value: 350,
                    },
                    whoIssued: {
                        value: "Константинопольский Александр",
                    },
                    replyByDate: {
                        value: "14.01.2021",
                    },
                    explanatory: {
                        value: "expired",
                    },
                    isShowRow: true,
                },
                {
                    filial: {
                        value: "Щербинка",
                    },
                    date: {
                        value: "19.11.2020",
                    },
                    measure: {
                        value: "Штраф",
                    },
                    reason: {
                        value: "Оплата десерта со скидкой 50%",
                    },
                    amount: {
                        value: 200,
                    },
                    whoIssued: {
                        value: "admin scherbinka",
                    },
                    replyByDate: {
                        value: "21.11.2020",
                    },
                    explanatory: {
                        value: "written",
                    },
                    isShowRow: true,
                },
                {
                    filial: {
                        value: "Щербинка",
                    },
                    date: {
                        value: "11.10.2020",
                    },
                    measure: {
                        value: "Штраф",
                    },
                    reason: {
                        value: "Оплата десерта со скидкой 50%",
                    },
                    amount: {
                        value: 200,
                    },
                    whoIssued: {
                        value: "admin scherbinka",
                    },
                    replyByDate: {
                        value: "",
                    },
                    explanatory: {
                        value: "issued_fine",
                    },
                    isShowRow: true,
                },
                {
                    filial: {
                        value: "Щербинка",
                    },
                    date: {
                        value: "30.09.2020",
                    },
                    measure: {
                        value: "Премия",
                    },
                    reason: {
                        value: "Компенсация за короткую смену",
                    },
                    amount: {
                        value: 100,
                    },
                    whoIssued: {
                        value: "admin scherbinka",
                    },
                    replyByDate: {
                        value: "",
                    },
                    explanatory: {
                        value: "",
                    },
                    isShowRow: true,
                },
            ],
        },
        tableReferralsBroughtEmployees: {
            type: "referrals-brought-employees",
            actions: false,
            levels: 1,
            columns: [
                {
                    id: "fullname",
                    label: "ФИО",
                    fullName: "ФИО",
                    type: "string",
                    level: 0,
                    width: "29.5%",
                    colspan: 1,
                    characteristic: "",
                },
                {
                    id: "postAndRank",
                    label: "Текущие должности и разряды",
                    fullName: "Текущие должности и разряды",
                    type: "string",
                    width: "28%",
                    level: 0,
                    colspan: 1,
                    characteristic: "",
                },
                {
                    id: "filial",
                    label: "Филиал",
                    fullName: "Филиал",
                    type: "string",
                    width: "10%",
                    level: 0,
                    colspan: 1,
                    characteristic: "",
                },
                {
                    id: "whenQuestionnaireComplete",
                    label: "Анкета заполнена",
                    fullName: "Анкета заполнена",
                    type: "string",
                    width: "13%",
                    level: 0,
                    colspan: 1,
                    characteristic: "",
                },
                {
                    id: "whenHired",
                    label: "Принят на работу",
                    fullName: "Принят на работу",
                    type: "string",
                    width: "12.5%",
                    level: 0,
                    colspan: 1,
                    characteristic: "",
                },
                {
                    id: "bonuses",
                    label: "Бонусы",
                    fullName: "Бонусы",
                    type: "number",
                    width: "7%",
                    level: 0,
                    colspan: 1,
                    characteristic: "",
                },
            ],
            records: [
                {
                    fullname: {
                        value: "Иванова Ирина Юрьевна",
                    },
                    postAndRank: {
                        value: "Администратор филиала / 5 / основной<br>Повар-сушист / 3 / ВОК",
                    },
                    filial: {
                        value: "Щербинка",
                    },
                    whenQuestionnaireComplete: {
                        value: "18.04.2020",
                    },
                    whenHired: {
                        value: "25.04.2020",
                    },
                    bonuses: {
                        value: 390,
                    },
                    isShowRow: true,
                },
                {
                    fullname: {
                        value: "Смирнов Евгений Петрович",
                    },
                    postAndRank: {
                        value: "Администратор филиала / 8 / основной<br>Повар-сушист / 3 / суши",
                    },
                    filial: {
                        value: "Московский",
                    },
                    whenQuestionnaireComplete: {
                        value: "10.02.2020",
                    },
                    whenHired: {
                        value: "14.02.2020",
                    },
                    bonuses: {
                        value: 50,
                    },
                    isShowRow: true,
                },
            ],
        },
        tableReferralsHistoryBonuses: {
            type: "referrals-history-bonuses",
            actions: false,
            levels: 1,
            columns: [
                {
                    id: "dateOperation",
                    label: "Дата операции",
                    fullName: "Дата операции",
                    type: "date",
                    level: 0,
                    width: "11%",
                    colspan: 1,
                    characteristic: "",
                },
                {
                    id: "accruedWrittenOff",
                    label: "Начилено/списано",
                    fullName: "Начилено/списано",
                    type: "number",
                    width: "13.5%",
                    level: 0,
                    colspan: 1,
                    characteristic: "",
                },
                {
                    id: "broughtEmployee",
                    label: "Привед-й сотрудник",
                    fullName: "Приведенный сотрудник",
                    type: "string",
                    width: "33%",
                    level: 0,
                    colspan: 1,
                    characteristic: "",
                },
                {
                    id: "basicOfTransaction",
                    label: "Основание транз-и",
                    fullName: "Основание транзакции",
                    type: "string",
                    width: "42.5%",
                    level: 0,
                    colspan: 1,
                    characteristic: "",
                },
            ],
            records: [
                {
                    dateOperation: {
                        value: "10.12.2020",
                    },
                    accruedWrittenOff: {
                        value: 300,
                    },
                    broughtEmployee: {
                        value: "Иванова Ирина Юрьевна",
                    },
                    basicOfTransaction: {
                        value: "Достижение разряда <b>3</b> на должности <b>Повар-сушист</b>",
                    },
                    isShowRow: true,
                },
                {
                    dateOperation: {
                        value: "25.04.2020",
                    },
                    accruedWrittenOff: {
                        value: 90,
                    },
                    broughtEmployee: {
                        value: "Иванова Ирина Юрьевна",
                    },
                    basicOfTransaction: {
                        value: "Достижение сотрудником статуса <b>Работает</b>",
                    },
                    isShowRow: true,
                },
                {
                    dateOperation: {
                        value: "24.02.2020",
                    },
                    accruedWrittenOff: {
                        value: -40,
                    },
                    broughtEmployee: {
                        value: "",
                    },
                    basicOfTransaction: {
                        value: "Переведены на личный счет сотрудника",
                    },
                    isShowRow: true,
                },
                {
                    dateOperation: {
                        value: "14.02.2020",
                    },
                    accruedWrittenOff: {
                        value: 90,
                    },
                    broughtEmployee: {
                        value: "Смирнов Евгений Петрович",
                    },
                    basicOfTransaction: {
                        value: "Достижение сотрудником статуса <b>Работает</b>",
                    },
                    isShowRow: true,
                },
            ],
        },

        tableDocumentsActingDocuments: {
            type: "documents-acting-documents",
            actions: true,
            levels: 1,
            columns: [
                {
                    id: "document",
                    label: "Документ",
                    fullName: "Документ",
                    type: "string",
                    level: 0,
                    width: "57%",
                    colspan: 1,
                    characteristic: "",
                },
                {
                    id: "shelfLife",
                    label: "Срок годности",
                    fullName: "Срок годности",
                    type: "date",
                    width: "13%",
                    level: 0,
                    colspan: 1,
                    characteristic: "",
                },
                {
                    id: "files",
                    label: "Файлы",
                    fullName: "Файлы",
                    type: "string",
                    width: "10%",
                    level: 0,
                    colspan: 1,
                    characteristic: "",
                },
                {
                    id: "added",
                    label: "Добавлен",
                    fullName: "Добавлен",
                    type: "date",
                    width: "10%",
                    level: 0,
                    colspan: 1,
                    characteristic: "",
                },
            ],
            records: [
                {
                    categoryName: "Обязательные для всех",
                    isHaveDocumentsExpired: true,
                    isHaveExpirationDate: false,
                    records: [
                        {
                            id: 1,
                            document: {
                                value: "СНИЛС",
                            },
                            shelfLife: {
                                value: "22.07.2025",
                            },
                            files: {
                                value: "1 файл",
                            },
                            added: {
                                value: "10.01.2021",
                            },
                            documentExpired: true,
                            isShowRow: true,
                        },
                    ],
                },
                {
                    categoryName: "Обязательные для трудоустройства",
                    isHaveDocumentsExpired: false,
                    isHaveExpirationDate: false,
                    records: [
                        {
                            id: 2,
                            document: {
                                value: "ИНН",
                            },
                            shelfLife: {
                                value: "22.07.2050",
                            },
                            files: {
                                value: "2 файла",
                            },
                            added: {
                                value: "10.01.2021",
                            },
                            isShowRow: true,
                        },
                    ],
                },
                {
                    categoryName: "Специальные",
                    isHaveDocumentsExpired: true,
                    isHaveExpirationDate: true,
                    records: [
                        {
                            id: 3,
                            document: {
                                value: "Регистрация",
                            },
                            shelfLife: {
                                value: "08.06.2021",
                            },
                            files: {
                                value: "1 файл",
                            },
                            added: {
                                value: "10.12.2020",
                            },
                            expirationDateComingSoon: true,
                            isShowRow: true,
                        },
                        {
                            id: 4,
                            document: {
                                value: "Медицинский полюс",
                            },
                            shelfLife: {
                                value: "20.02.2021",
                            },
                            files: {
                                value: "2 файла",
                            },
                            added: {
                                value: "10.12.2020",
                            },
                            documentExpired: true,
                            isShowRow: true,
                        },
                    ],
                },
            ],
        },

        tableDocumentsArchive: {
            type: "documents-archive",
            actions: true,
            levels: 1,
            columns: [
                {
                    id: "document",
                    label: "Документ",
                    fullName: "Документ",
                    type: "string",
                    level: 0,
                    width: "57%",
                    colspan: 1,
                    characteristic: "",
                },
                {
                    id: "shelfLife",
                    label: "Срок годности",
                    fullName: "Срок годности",
                    type: "date",
                    width: "13%",
                    level: 0,
                    colspan: 1,
                    characteristic: "",
                },
                {
                    id: "files",
                    label: "Файлы",
                    fullName: "Файлы",
                    type: "string",
                    width: "10%",
                    level: 0,
                    colspan: 1,
                    characteristic: "",
                },
                {
                    id: "added",
                    label: "Добавлен",
                    fullName: "Добавлен",
                    type: "date",
                    width: "10%",
                    level: 0,
                    colspan: 1,
                    characteristic: "",
                },
            ],
            records: [
                {
                    categoryName: "Обязательные для всех",
                    records: [
                        {
                            document: {
                                value: "Санитарная книжка",
                            },
                            shelfLife: {
                                value: "22.07.2025",
                            },
                            files: {
                                value: "1 файл",
                            },
                            added: {
                                value: "10.01.2021",
                            },
                            isShowRow: true,
                        },
                    ],
                },
                {
                    categoryName: "Специальные",
                    records: [
                        {
                            document: {
                                value: "Регистрация",
                            },
                            shelfLife: {
                                value: "08.06.2020",
                            },
                            files: {
                                value: "2 файла",
                            },
                            added: {
                                value: "10.12.2019",
                            },
                            isShowRow: true,
                        },
                    ],
                },
            ],
        },
    },

    mutations: {
        saveFilter(state, filter) {
            // let filters = state.filters.sort();
            // let newFilter = filter.forEach(f => f);

            if (state.filters.length === 0) {
                filter.id = 1;
            } else {
                const filters = state.filters.sort((a, b) => a.id - b.id);

                const id = filters[filters.length - 1].id + 1;

                filter.id = id;
            }

            state.filters.push(filter);
        },

        removeItemFromInventoryItemsByPositionsTable(state, id) {
            state.tableInventoryItemsByPositions.records.forEach((group, groupIndex) => {
                group.records.forEach((record, recordId) => {
                    if (record.id === id) {
                        state.tableInventoryItemsByPositions.records[groupIndex].records.splice(recordId, 1);
                    }
                });
            });
        },

        hideItemFromInventoryItemsByPositionsTable(state, currentRecord) {
            let countIdenticalInventory = 0;
            state.tableInventoryItemsByPositions.records.forEach((group, groupIndex) => {
                let currentGroupIndex = null;
                group.records.forEach((record) => {
                    if (record.id === currentRecord.id) {
                        currentGroupIndex = groupIndex;
                    }
                });

                if (currentGroupIndex === groupIndex) {
                    group.records.forEach((record) => {
                        if (record.position.value === currentRecord.position.value) {
                            countIdenticalInventory += 1;
                        }
                    });
                }
            });

            state.tableInventoryItemsByPositions.records.forEach((group) => {
                group.records.forEach((record, recordId) => {
                    if (record.id === currentRecord.id && countIdenticalInventory === 1) {
                        record.dateIssue.value = "";
                        record.whoIssued.value = "";
                        record.status.desc = "notissued";
                        record.status.value = "Не выдан";
                    } else if (record.id === currentRecord.id) {
                        group.records.splice(recordId, 1);
                        const currentInventoryItemRecords = group.records
                            .filter((rec) => rec.position.value === currentRecord.position.value)
                            .sort((a, b) => {
                                const aa = a.dateIssue.value.split(".").reverse().join();
                                const bb = b.dateIssue.value.split(".").reverse().join();
                                if (aa < bb) {
                                    return 1;
                                }
                                if (aa > bb) {
                                    return -1;
                                }
                                return 0;
                            });
                        const c = group.records.findIndex((rec) => rec.id === currentInventoryItemRecords[0].id);
                        group.records[c].status.desc = "issued";
                    }
                });
            });
        },

        issuedInventoryInInventoryItemsTable(state, data) {
            state.tableInventoryItemsByPositions.records.forEach((group) => {
                group.records.forEach((record) => {
                    if (record.id === data.id) {
                        record.dateIssue.value = data.date;
                        record.whoIssued.value = data.name;
                        record.status.desc = "issued";
                        record.status.value = "Выдан";
                    }
                });
            });
        },

        issuedMoreInventoryInInventoryItemsTable(state, data) {
            state.tableInventoryItemsByPositions.records.forEach((group) => {
                group.records.forEach((record) => {
                    if (record.id === data.id) {
                        record.status.desc = "hasalready";
                        group.records.push({
                            id: {
                                value: record.id + 10000,
                            },
                            position: {
                                value: record.position.value,
                            },
                            status: {
                                value: "Выдан",
                                desc: "issued",
                            },
                            shelfLife: {
                                value: "",
                            },
                            dateIssue: {
                                value: data.date,
                            },
                            whoIssued: {
                                value: data.name,
                            },
                            isShowRow: true,
                        });
                    }
                });
            });
        },

        actingDocumentsMoveItemToArchive(state, id) {
            state.tableDocumentsActingDocuments.records.forEach((group, groupIndex) => {
                group.records.forEach((record, recordIndex) => {
                    if (record.id === id)
                        state.tableDocumentsActingDocuments.records[groupIndex].records.splice(recordIndex, 1);
                    if (state.tableDocumentsActingDocuments.records[groupIndex].records.length === 0)
                        state.tableDocumentsActingDocuments.records.splice(groupIndex, 1);
                });
            });
        },
    },

    getters: {
        getTableData(state) {
            return state.table;
        },

        getTableMoveInCompany(state) {
            return state.tablePersonalEmployeeMoveInCompany;
        },

        getTableMainFactors(state) {
            return state.tablePersonalEmployeeMainFactors;
        },

        getTableFinancePersonalAccount(state) {
            return state.tablePersonalFinancePersonalAccount;
        },

        getTableFinanceDeposit(state) {
            return state.tablePersonalFinanceDeposit;
        },

        getTableInventoryItemsByPositions(state) {
            return state.tableInventoryItemsByPositions;
        },

        getTableInventoryItemsHistoryChanges(state) {
            return state.tableInventoryItemsChanges;
        },

        getTableDiscipline(state) {
            return state.tablePersonalEmployeeDiscipline;
        },

        getTableReferralsBroughtEmployees(state) {
            return state.tableReferralsBroughtEmployees;
        },

        getTableReferralsHistoryBonuses(state) {
            return state.tableReferralsHistoryBonuses;
        },

        getTableDocumentsActingDocuments(state) {
            return state.tableDocumentsActingDocuments;
        },

        getTableDocumentsArchive(state) {
            return state.tableDocumentsArchive;
        },

        getFields(state) {
            return state.fields;
        },

        getEmployeesFilters(state) {
            return state.filters;
        },

        getEmployeesFilterById(state) {
            return (id) => state.filters.find((f) => f.id === id);
        },

        getBranches(state) {
            return state.branches;
        },

        getBranchesById(state) {
            return (ids) => state.branches.filter((item) => ids.includes(`${item.id}`));
        },

        getBranchesByIdNot(state) {
            return (ids) => state.branches.filter((item) => !ids.includes(`${item.id}`));
        },

        getPositions(state) {
            return state.positions;
        },
    },
};
